import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { RecordsListItem } from "../../types/common";
import { Button } from "../Button";
import { ArrowUp, ArrowDown } from "../Icons";

import styles from "./Record.module.scss";

interface Props {
  data: RecordsListItem;
}

const CHARACTER_LIMIT = 250;

const Record = (props: Props) => {
  const { id, text, createdBy, createdDate } = props.data;
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowed, setIsOverflowed] = useState(
    text.length > CHARACTER_LIMIT
  );

  useEffect(() => {
    if (contentRef.current) {
      const { clientHeight, scrollHeight } = contentRef.current;

      setIsOverflowed(scrollHeight > clientHeight);
    }
  }, [text]);

  return (
    <div className={styles.record}>
      <div className={styles.recordHeader}>
        <div className={styles.recordAuthor}>{createdBy}</div>
        <div className={styles.recordDate}>{createdDate}</div>
      </div>
      <div
        ref={contentRef}
        className={classnames(
          styles.recordText,
          isExpanded && styles.recordTextExpanded
        )}
      >
        {text}
      </div>
      {isOverflowed && (
        <Button
          variant="inline"
          id={`${id}-record-expand-btn`}
          iconComponent={isExpanded ? ArrowUp : ArrowDown}
          onClick={() => setIsExpanded((prevIsExpanded) => !prevIsExpanded)}
        >
          {t(`recordsList.show${isExpanded ? "Less" : "More"}`)}
        </Button>
      )}
    </div>
  );
};

export default Record;
